export default "__VITE_ASSET__CQ9U0br2__"